export default __webpack_public_path__ + "static/media/rheumatology.cf4f8a33.png";